'use client'

import { useEffect } from 'react'

import {
  addToHistory,
  COOKIE_DAYS,
  COOKIE_NAME,
  normalizePerformanceId,
  parseHistory,
  serializeHistory,
} from '@/app/lib/recentlyViewed'
import { getCookie, setCookie } from '@/app/lib/utils'

/**
 * Da de alta un evento en el historial de "vistos recientemente" al visitar su
 * ficha (specs/024-vistos-recientemente, FR-030–FR-037).
 *
 * **Mecanismo reutilizable, hoy sin consumidor.** Se entrega listo para que la
 * futura ficha de evento de la web general lo adopte con una sola línea:
 *
 * ```tsx
 * 'use client'
 * useRegisterRecentlyViewed(performance.id)
 * ```
 *
 * No se cablea en ninguna página en este feature: canales quedó fuera de
 * alcance por completo y la ficha de la web general no existe todavía (FR-032).
 * Es agnóstico de la página que lo invoca: recibe el identificador del evento,
 * no la ruta ni el canal (FR-032a).
 *
 * Acepta el id con o sin el prefijo canónico (`performance-`); si no se puede
 * normalizar, no escribe nada. Escribe una sola vez por id y montaje, después
 * del render, de modo que no bloquea ni retrasa el contenido de la ficha ni
 * afecta a su caché (FR-038).
 */
export function useRegisterRecentlyViewed(
  performanceId: string | null | undefined,
): void {
  useEffect(() => {
    const id = normalizePerformanceId(performanceId)
    if (!id) return

    const next = addToHistory(parseHistory(getCookie(COOKIE_NAME)), id)
    setCookie(COOKIE_NAME, serializeHistory(next), COOKIE_DAYS)
  }, [performanceId])
}
